import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { useLocale } from '~/composables/useLocale';

interface Props {
  hasMonthlyPlans: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PlanHeader',
  props: {
    hasMonthlyPlans: { type: Boolean }
  },
  setup(__props: any) {

const locale = useLocale();

const { $isFlagOn } = useContext();

return { __sfc: true,locale, $isFlagOn }
}

})